import { HttpClient } from "@angular/common/http";
import "rxjs/add/operator/map";
import { Injectable } from "@angular/core";
import {
  IBusiness,
  IConfigPage,
  IItem,
  IITemModuleList,
  IWelcomePage,
  ModuleTypes,
  PageTypes,
} from "src/app/metadata/interfaces/page/Pages";

import { forkJoin, from } from "rxjs";
import * as localforage from "localforage";
import { ApiConstant, UtilService } from "src/app/constants/app.constant";

interface IntegrA_Response {
  Code: number;
  Message: string;
  Response: any;
}

@Injectable({
  providedIn: "root",
})
export class SkyaccessApiService {
  // BaseUrl = "https://www.skyaccess.us/IntegraDevApi/api/skyaccessdesign/";
  // BaseUrl =  "https://www.skyaccess.eu/IntegraDevApiV2/api/v1/SkyAccessDesigns/"; - this need to be tested again

  BaseUrl = ApiConstant.baseUrlV4 + "SkyAccessDesigns/";

  skyAccessData;

  loadSkyAccess_DB: LocalForage;
  isSkyAccessCached = false;

  constructor(private http: HttpClient) {}

  setConfigPage(configPage: IConfigPage) {
    let items = [
      ...configPage.Header,
      ...configPage.MainNenu,
      ...configPage.KeyMenu,
    ];
    return this.updateItems(items).map((value) => {
      return value;
    });
  }

  getConfigPage() {
    return this.getPageView(PageTypes.SA_ConfigView).map((value) => {
      let pageList = value as any;

      var reorderHeaders = (headers) => {
        const headersTemp = new Array(6).fill({}) as any[];
        headers.forEach((header) => {
          switch (header.ID) {
            case "HeaderColor":
              headersTemp[0] = header;
              break;
            case "HeaderBgColor":
              headersTemp[1] = header;
              break;
            case "HeaderIcon":
              headersTemp[2] = header;
              break;
            case "ShowHeaderIcon":
              headersTemp[3] = header;
              break;
            case "HeaderTitle":
              headersTemp[4] = header;
              break;
            case "HeaderFixed":
              headersTemp[5] = header;
              break;
            default:
              break;
          }
        });
        return headersTemp;
      };
      var reorderMainMenu = (menuItems) => {
        const menuItemsTemp = new Array(4).fill({}) as any[];
        menuItems.forEach((item) => {
          switch (item.ID) {
            case "MainMenuColor":
              menuItemsTemp[0] = item;
              break;
            case "MainMenuBgColor":
              menuItemsTemp[1] = item;
              break;
            case "BgImage":
              menuItemsTemp[2] = item;
              break;
            case "MmFixed":
              menuItemsTemp[3] = item;
              break;
            default:
              break;
          }
        });
        return menuItemsTemp;
      };
      var reorderKeyMenu = (keyMenuItems) => {
        const keyMenuItemsTemp = new Array(2).fill({}) as any[];
        keyMenuItems.forEach((item) => {
          switch (item.ID) {
            case "MainMenuColor":
              keyMenuItemsTemp[0] = item;
              break;
            case "MainMenuBgColor":
              keyMenuItemsTemp[1] = item;
              break;
            default:
              break;
          }
        });
        return keyMenuItemsTemp;
      };

      let configPage = {
        Header: [],
        MainNenu: [],
        KeyMenu: [],
      };
      pageList.forEach((element) => {
        switch (element.ModuleType) {
          case ModuleTypes.Header:
            configPage.Header.push(element);
            break;
          case ModuleTypes.MainNenu:
            configPage.MainNenu.push(element);
            break;
          case ModuleTypes.KeyMenu:
            configPage.KeyMenu.push(element);
            break;

          default:
            break;
        }
      });
      configPage.Header = reorderHeaders(configPage.Header);
      configPage.MainNenu = reorderMainMenu(configPage.MainNenu);
      configPage.KeyMenu = reorderKeyMenu(configPage.KeyMenu);

      return configPage;
    });
  }

  setGnSettings(gnSettings: IItem[]) {
    let items = [...gnSettings];
    return this.updateItems(items).map((value) => {
      return value;
    });
  }

  getGnSetting() {
    return this.getPageView(PageTypes.SA_GenSetting).map((value) => {
      //console.log(value)
      let pageList = value as any;
      let gnSetting = [...pageList];
      gnSetting;

      return gnSetting;
    });
  }

  setModuleList1(moduleList1: IItem[]) {
    let items = [...moduleList1];
    return this.updateItems(items).map((value) => {
      return value;
    });
  }

  getModuleList1() {
    return this.getPageView(PageTypes.SA_ModuleSetting).map((value) => {
      let pageList = value as any;

      let moduleList1 = [];
      pageList.forEach((element) => {
        if (element.ModuleType === ModuleTypes.IsHotel) {
          moduleList1.push(element);
        }
      });

      return moduleList1;
    });
  }

  setModuleList2(moduleList2: IItem[]) {
    let items = [...moduleList2];
    return this.updateItems(items).map((value) => {
      return value;
    });
  }

  getModuleList2() {
    return this.getPageView(PageTypes.SA_ModuleSetting).map((value) => {
      let pageList = value as any;

      let moduleList2 = [];
      pageList.forEach((element) => {
        if (element.ModuleType === ModuleTypes.IsGuide) {
          moduleList2.push(element);
        }
      });

      return moduleList2;
    });
  }

  setWelcomePage(welcomePage: IWelcomePage) {
    let items = [
      ...welcomePage.Hotel,
      ...welcomePage.CityGuide,
      welcomePage.HLocation,
      ...welcomePage.CityLocation,
      welcomePage.WVideo,
      welcomePage.WBgImg,
      ...welcomePage.WGuestData,
    ];
    return this.updateItems(items).map((value) => {
      return value;
    });
  }

  getWelcomePage() {
    return this.getPageView(PageTypes.SA_WelcomeView).map((value) => {
      let pageList = value as any;

      let welcomePage = {
        Hotel: [],
        CityGuide: [],
        HLocation: null,
        CityLocation: [],
        WVideo: null,
        WBgImg: null,
        WGuestData: [],
      };

      pageList.forEach((element) => {
        switch (element.ModuleType) {
          case ModuleTypes.IsHotel:
            welcomePage.Hotel.push(element);
            break;
          case ModuleTypes.IsGuide:
            welcomePage.CityGuide.push(element);
            break;
          case ModuleTypes.HLocation:
            welcomePage.HLocation = element;
            break;
          case ModuleTypes.CityLocation:
            welcomePage.CityLocation.push(element);
            break;
          case ModuleTypes.WVideo:
            welcomePage.WVideo = element;
            break;
          case ModuleTypes.WBgImg:
            welcomePage.WBgImg = element;
            break;
          case ModuleTypes.WGData:
            welcomePage.WGuestData.push(element);
        }
      });

      return welcomePage;
    });
  }

  createNewBusinessDetailsTemplate(items: IItem[]) {
    return this.createItems(items).map((value) => {
      return value;
    });
  }

  deleteBusinessDetailsTemplate(items: IItem[]) {
    return this.deleteItems(items).map((value) => {
      return value;
    });
  }

  setBusinesses(businesses: IBusiness) {
    let items = [];
    businesses.Hotel.forEach((element) => {
      items.push(element.ItemModule);
      element.Itemlist.forEach((object) => {
        object.Items.forEach((item) => {
          items.push(item);
        });
      });
    });
    businesses.CityGuide.forEach((element) => {
      items.push(element.ItemModule);
      element.Itemlist.forEach((object) => {
        object.Items.forEach((item) => {
          items.push(item);
        });
      });
    });

    return this.updateItems(items).map((value) => {
      return value;
    });
  }

  getBusinesses() {
    return this.getPageView(PageTypes.SA_BusinessesView).map((items) => {
      let businesses: IBusiness;

      businesses = this.modifyToBusinessObject(items);

      return businesses;
    });
  }

  modifyToBusinessObject(items: IItem[]) {
    let businesses: IBusiness = {
      Hotel: [],
      CityGuide: [],
    };
    let moduleListHotel = [];
    let moduleListGuide = [];
    let IDsHotel = [
      "business-module-1000",
      "business-module-10000",
      "business-module-100000",
      "business-module-2000",
      "business-module-20000",
      "business-module-200000",
      "business-module-20000000",
    ];
    let IDsGuide = [
      "guide-module-1000",
      "guide-module-10000",
      "guide-module-100000",
      "guide-module-2000",
      "guide-module-20000",
      "guide-module-200000",
      "guide-module-20000000",
    ];
    for (let index = 0; index < 7; index++) {
      moduleListHotel.push([]);
      moduleListGuide.push([]);
    }

    items.forEach((item) => {
      switch (item.ModuleType) {
        case ModuleTypes.IsModuleHotel1:
          moduleListHotel[0].push(item);
          break;
        case ModuleTypes.IsModuleHotel2:
          moduleListHotel[1].push(item);
          break;
        case ModuleTypes.IsModuleHotel3:
          moduleListHotel[2].push(item);
          break;
        case ModuleTypes.IsModuleHotel4:
          moduleListHotel[3].push(item);
          break;
        case ModuleTypes.IsModuleHotel5:
          moduleListHotel[4].push(item);
          break;
        case ModuleTypes.IsModuleHotel6:
          moduleListHotel[5].push(item);
          break;
        case ModuleTypes.IsModuleHotel7:
          moduleListHotel[6].push(item);
          break;
        case ModuleTypes.IsModuleGuide1:
          moduleListGuide[0].push(item);
          break;
        case ModuleTypes.IsModuleGuide2:
          moduleListGuide[1].push(item);
          break;
        case ModuleTypes.IsModuleGuide3:
          moduleListGuide[2].push(item);
          break;
        case ModuleTypes.IsModuleGuide4:
          moduleListGuide[3].push(item);
          break;
        case ModuleTypes.IsModuleGuide5:
          moduleListGuide[4].push(item);
          break;
        case ModuleTypes.IsModuleGuide6:
          moduleListGuide[5].push(item);
          break;
        case ModuleTypes.IsModuleGuide7:
          moduleListGuide[6].push(item);
          break;
        default:
          break;
      }
    });
    moduleListHotel.forEach((moduleListHotelItems, currentIndex) => {
      businesses.Hotel.push(
        this.getItemModuleList(
          moduleListHotelItems,
          IDsHotel[currentIndex],
          true
        )
      );
    });
    moduleListGuide.forEach((moduleListGuideItems, currentIndex) => {
      businesses.CityGuide.push(
        this.getItemModuleList(
          moduleListGuideItems,
          IDsGuide[currentIndex],
          false
        )
      );
    });

    return businesses;
  }

  getItemModuleList(items: IItem[], id: string, isHotel: boolean) {
    let itemModuleList: IITemModuleList = {
      ItemModule: null,
      Itemlist: [],
    };

    let orderSet: Set<number> = new Set();

    items.forEach((item) => {
      if (item.ID !== id) {
        orderSet.add(item._Ord);
      }
    });
    let orderedArray = Array.from(orderSet);
    orderedArray.sort((a, b) => {
      if (a > b) return 1;
      if (a < b) return -1;
      return 0;
    });

    let numOfIterations = isHotel ? 4 : 5;

    for (let index = 0; index < orderedArray.length; index++) {
      itemModuleList.Itemlist.push({
        Items: new Array(numOfIterations),
      });
    }

    // for (let i = 0; i <= itemModuleList.Itemlist.length; i++) {
    //   for (let j = 0; j <= numOfIterations; j++) {
    //     itemModuleList.Itemlist[i].Items.push(null);
    //   }
    // }

    items.forEach((item) => {
      if (item.ID === id) {
        itemModuleList.ItemModule = item;
      } else {
        let index = orderedArray.indexOf(item._Ord);
        if (isHotel) {
          switch (item.ID) {
            case "Title":
              itemModuleList.Itemlist[index].Items[0] = item;
              break;

            case "Img":
              itemModuleList.Itemlist[index].Items[1] = item;
              break;

            case "BtTxt":
              itemModuleList.Itemlist[index].Items[2] = item;
              break;

            case "ExterLink":
              itemModuleList.Itemlist[index].Items[3] = item;
              break;

            case "Descp":
              itemModuleList.Itemlist[index].Items[4] = item;
              break;

            default:
              "Error: Element does not match any of the switch cases specified!";
              break;
          }
        } else {
          switch (item.ID) {
            case "Geo":
              // case "GuideGeo2":
              itemModuleList.Itemlist[index].Items[0] = item;
              break;
            case "Title2":
              itemModuleList.Itemlist[index].Items[1] = item;
              break;

            case "Img2":
              itemModuleList.Itemlist[index].Items[2] = item;
              break;

            case "BtTxt2":
              itemModuleList.Itemlist[index].Items[3] = item;
              break;

            case "ExterLink2":
              itemModuleList.Itemlist[index].Items[4] = item;
              break;

            case "Descp2":
              itemModuleList.Itemlist[index].Items[5] = item;
              break;

            default:
              "Error: Element does not match any of the switch cases specified!";
              break;
          }
        }
      }
    });
    return itemModuleList;
  }

  test(num = 5) {
    //
    //
    //
    this.getConfigPage();
    this.getGnSetting();
    this.getModuleList1();
    this.getModuleList2();
  }

  createItems(items: IItem[]) {
    let requests = [];
    items.forEach((item) => {
      const apiDataModel = {
        // "_SkyAccessDesignID": null,
        _ID: "",
        _StaticTxt: "",
        _VarTxt: "",
        _Color: "",
        _BgColor: "",
        _PageType: 100,
        _EntryType: 100,
        _ModuleType: 100,
        _Enabled: 0,
        _Links: "",
        _Classes: "",
        _Longitude: "",
        _Latitude: "",
        _StatTranslate: "",
        _FontSz: "",
        _CreationDate: "",
        _UpdatedDate: "",
        _FontFam: "Tahoma",
        _High: "",
        _Wdth: "",
        _Eff: "",
        _Speed: 100,
        _Ord: 100,
        _SysNumber:
          localStorage.getItem("SysCode") != undefined
            ? +localStorage.getItem("SysCode").replace("\n", "")
            : 286331157,
      };
      Object.keys(item).forEach((key) => {
        if (key.includes("_")) apiDataModel[key] = item[key];
        else apiDataModel["_" + key] = item[key];
      });
      requests.push(apiDataModel);
    });
    // return forkJoin(requests);
    return this.http.post(this.BaseUrl + "BulkAction", {
      _ActionType: 0,
      Templates: requests,
    });
  }

  deleteItems(items: IItem[]) {
    let requests = [];
    items.forEach((item) => {
      const apiDataModel = {
        _SkyAccessDesignID: null,
        _ID: "",
        _StaticTxt: "",
        _VarTxt: "",
        _Color: "",
        _BgColor: "",
        PageType: 100,
        EntryType: 100,
        ModuleType: 100,
        Enabled: 0,
        Links: "",
        Classes: "",
        Longitude: "",
        Latitude: "",
        StatTranslate: "",
        FontSz: "",
        _CreationDate: "",
        _UpdatedDate: "",
        FontFam: "Tahoma",
        High: "",
        Wdth: "",
        _Eff: "",
        _Speed: 100,
        _Ord: 100,
        _SysNumber:
          localStorage.getItem("SysCode") != undefined
            ? +localStorage.getItem("SysCode").replace("\n", "")
            : 286331157,
      };
      Object.keys(item).forEach((key) => {
        apiDataModel[key] = item[key];
      });
      requests.push(
        this.http.delete(
          this.BaseUrl + "DeleteSkyAccessDesign/" + item.SkyAccessDesignID
        )
      );
      // requests.push(item)
    });
    return forkJoin(requests);
    // return this.http.post('https://www.skyaccess.us/IntegraDevApi/api/skyaccessdesign/BulkAction', {
    //   "_ActionType": 1,
    //   "Templates": requests
    // });
  }

  updateItems(items: IItem[]) {
    let requests = [];
    items.forEach((item) => {
      const apiDataModel = {
        // "_SkyAccessDesignID": null,
        _ID: "",
        _StaticTxt: "",
        _VarTxt: "",
        _Color: "",
        _BgColor: "",
        _PageType: 100,
        _EntryType: 100,
        _ModuleType: 100,
        _Enabled: 0,
        _Links: "",
        _Classes: "",
        _Longitude: "",
        _Latitude: "",
        _StatTranslate: "",
        _FontSz: "",
        _CreationDate: "",
        _UpdatedDate: "",
        _FontFam: "Tahoma",
        _High: "",
        _Wdth: "",
        _Eff: "",
        _Speed: 100,
        _Ord: 100,
        _SysNumber:
          localStorage.getItem("SysCode") != undefined
            ? +localStorage.getItem("SysCode").replace("\n", "")
            : 286331157,
      };
      Object.keys(item).forEach((key) => {
        if (key.includes("_")) apiDataModel[key] = item[key];
        else apiDataModel["_" + key] = item[key];
      });
      requests.push(apiDataModel);
    });
    // return forkJoin(requests);
    return this.http.post(this.BaseUrl + "BulkAction", {
      _ActionType: 3,
      Templates: requests,
    });
  }

  getPageView(pageView: PageTypes) {
    //console.log(pageView)
    const data = [];
    if (this.skyAccessData)
      this.skyAccessData.forEach((element) => {
        if (element.PageType === pageView) data.push(element);
      });
    return from(Promise.resolve(data));
  }

  getPages() {
    // (this.skyAccessData);
    // if(this.loadSkyAccess_DB == undefined){
    //   this.loadSkyAccess_DB = localforage.createInstance({
    //     name: "data_cache",
    //     storeName: "skyAccess"
    //   });
    // }
    // if(this.skyAccessData != null){
    //   this.isSkyAccessCached = true;
    //   return from(Promise.resolve(this.skyAccessData));
    // }

    var SystemCode = UtilService.GetSystemCode(true);

    return this.http
      .post(this.BaseUrl + "QueryBuilder", {
        _Limit: 1000,
        _Skip: 0,
        Order: {},
        Fields: {
          SkyAccessDesign:
            "_SkyAccessDesignID;_ID; _StaticTxt; _VarTxt; _Color; _BgColor; _PageType; _EntryType; _ModuleType; _Enabled; _Links; _Classes; _Longitude; _Latitude; _StatTranslate; _FontSz; _FontFam; _High; _Wdth; _Ord; _Eff; _Speed",
        },
        WHERE: {
          SkyAccessDesign: `_SysNumber=${SystemCode}`,
        },
        Condition: {},
        LastUpdated: null,
      })
      .map((res) => {
        // if(!this.isSkyAccessCached){
        //   this.loadSkyAccess_DB.setItem("skyList", res).then(val => ("SkyAccess Cached successfully!"));
        // }
        return res as any as IItem[];
      });
  }
}
